import { useEffect, useMemo } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import styles from './styles.module.scss';
import { SignupContextProvider } from '@context/signup_context';
import Illustrations from '@sections/signup/illustrations';
import { useTranslation } from 'react-i18next';
import Button from '@components/common/button';
import Typography from '@components/common/typography';
import { routes } from '@const/routes';
import logo from '@svg/dark_header_logo.svg';
import { useLocales } from '@hooks/helpers/useLocales';

const AuthProvider = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { i18n, t } = useTranslation('sign_in');
    const { submitLocale } = useLocales();

    const handleChangeLanguage = () => {
        const lang = i18n.language === 'en' ? 'fr' : 'en';
        i18n.changeLanguage(lang);
        localStorage.setItem('language', lang);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    const isShowLoginLink = useMemo(() => {
        const loginRoutes = [routes.signup, routes.forgot_password];
        return loginRoutes.includes(location.pathname);
    }, [location]);

    return (
        <SignupContextProvider>
            <div className={styles.wrapper}>
                <div className={styles.content_wrapper}>
                    <div className={styles.content}>
                        <div className={styles.content_header}>
                            <Link to={routes.signin}>
                                <img src={logo} alt="Logo" />
                            </Link>
                            <div className={styles.content_actions}>
                                {/*<Button
                                    className={styles.auth_button}
                                    variant="text-gold"
                                    onClick={() =>
                                        navigate(isShowLoginLink ? routes.signin : routes.signup)
                                    }>
                                    {isShowLoginLink ? t('signin') : t('signup')}
                                </Button>*/}
                                <Button className={styles.language} onClick={handleChangeLanguage}>
                                    <Typography
                                        className={i18n.language === 'en' ? styles.isActive : ''}
                                        variant="body2">
                                        EN
                                    </Typography>
                                    |
                                    <Typography
                                        className={i18n.language === 'fr' ? styles.isActive : ''}
                                        variant="body2">
                                        FR
                                    </Typography>
                                </Button>
                            </div>
                        </div>
                        <div className={styles.body}>
                            <Outlet />
                        </div>
                    </div>
                    <div className={styles.content_footer}>
                        <div className={styles.links_wrapper}>
                            <Button
                                variant="text-gray"
                                onClick={() => window.open(routes.terms_of_service, '_blank')}>
                                <Typography variant="body4">
                                    {submitLocale('terms_of_service')}
                                </Typography>
                            </Button>
                            <Button
                                variant="text-gray"
                                onClick={() => window.open(routes.privacy_policy, '_blank')}>
                                <Typography variant="body4">
                                    {submitLocale('privacy_policy')}
                                </Typography>
                            </Button>
                        </div>
                        <div className={styles.illustration_footer}>© XEPPT 2025</div>
                    </div>
                </div>
                <div className={styles.illustration_wrapper}>
                    <div className={styles.illustration_header}>
                        <div className={styles.links_wrapper}>
                            <Button
                                variant="text-gray"
                                onClick={() => window.open(routes.terms_of_service, '_blank')}>
                                {submitLocale('terms_of_service')}
                            </Button>
                            <Button
                                variant="text-gray"
                                onClick={() => window.open(routes.privacy_policy, '_blank')}>
                                {submitLocale('privacy_policy')}
                            </Button>
                        </div>
                        <Button
                            variant="text-gray"
                            className={styles.language}
                            onClick={handleChangeLanguage}>
                            <Typography
                                className={i18n.language === 'en' ? styles.isActive : ''}
                                variant="body2">
                                EN
                            </Typography>
                            |
                            <Typography
                                className={i18n.language === 'fr' ? styles.isActive : ''}
                                variant="body2">
                                FR
                            </Typography>
                        </Button>
                    </div>
                    <Illustrations className={styles.illustration} />
                    <div className={styles.illustration_footer}>© XEPPT 2025</div>
                </div>
            </div>
        </SignupContextProvider>
    );
};

export default AuthProvider;
